import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ModalData } from './modal-data-model';

@Component({
    selector: 'carm-modal-dialog',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
  })
  export class ModalComponent {

    constructor(
        private router: Router,
        public dialogRef: MatDialogRef<ModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ModalData) {
            dialogRef.disableClose = true;
        }

    closeModal(button?: string) {
        this.dialogRef.close(button);
    }
}
